// extracted by mini-css-extract-plugin
export var closeButton = "_1t-3";
export var header = "_1t-0";
export var link = "_1t-1";
export var retryButton = "_1t-2";